<template>
  <div id="app">
    <ActivityPage />
  </div>
</template>

<script>
import ActivityPage from '@/views/ActivityPage.vue'
export default { name: 'App', components: { ActivityPage } }
</script>
